import React, { useEffect, useState } from "react";
import "./documantation.css";
import { Tabs, TabList, Tab } from "react-tabs";
import ApiDocService from "../../services/userGuide/apiDocService";


export default function ApiDocumentation() {
  // =========================
  // STATE
  // =========================
  const [docs, setDocs] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 767.98 : false
  );

  // =========================
  // RESPONSIVE HANDLER
  // =========================
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767.98);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // =========================
  // LOAD API DOCS
  // =========================
  useEffect(() => {
    loadDocs();
  }, []);

  const loadDocs = async () => {
    try {
      const res = await ApiDocService.getDocs();
      const data = res.data?.data || res.data || [];

      setDocs(data);

      if (data.length > 0) {
        setSelectedDoc(data[0]);
      }
    } catch (err) {
      console.error("Failed to load API docs:", err);
    }
  };

  // =========================
  // SEARCH (DEBOUNCE)
  // =========================
  useEffect(() => {
    if (!search) {
      setResults([]);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        setLoading(true);

        const res = await ApiDocService.globalSearch(search);
        setResults(res.data?.results || []);
      } catch (err) {
        console.error("Search error:", err);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [search]);

  // =========================
  // HANDLERS
  // =========================
  const handleSelectDoc = (doc) => {
    setSelectedDoc(doc);
    setSearch("");
    setResults([]);
  };

  const handleResultClick = (result) => {
    const doc = docs.find((d) => d.id === result.doc_id);
    if (doc) {
      handleSelectDoc(doc);
    }
  };

  // =========================
  // RENDER
  // =========================
  return (
    <div className="doc-page">
      <main className="doc-main">
        <div className="container-fluid h-100 py-3">
          <div className="row g-3 h-100">




            {/* =========================
                CENTER VIEW (HTML)
            ========================= */}

            <div className="card h-100 shadow-sm">
              <div className="card-body p-0">

                {selectedDoc?.file ? (
                  <iframe
                    src={selectedDoc.file}
                    title="Integration Guide"
                    className="doc-iframe"
                  />
                ) : (
                  <div className="d-flex justify-content-center align-items-center h-100 text-muted">
                    Select a document to view
                  </div>
                )}

              </div>
            </div>





          </div>
        </div>
      </main>
    </div>
  );
}